@if (hasViewPermission || hasEditPermission) {
    <div class="card panel-flat-color secondary-panel">
        <div class="panel-flat-header" (click)="expandOrCollapse()" [ngClass]="{'pointer': !isEditMode}">
            <panel-chevron [showBody]="showBody"></panel-chevron>
            <h3>Contract Terms</h3>
            <div class="float-end d-flex align-items-center header-button-container"
                 (click)="$event.stopPropagation()">
                @if (showBody) {
                    <div
                        style="margin-top: -10px;"
                        class="d-flex align-items-center me-4">
                        <span style="margin-right: 5px;">Tax Year:</span>
                        <!-- Do not change the order of ngModelChange and ngModel! It will change functionality for some weird reason (that I'm using to my advantage) -->
                        <select (ngModelChange)="yearChanged()"
                                [(ngModel)]="selectedYear"
                                class="form-select form-select-sm form-select-nb d-inline-block w-auto">
                            <option value="0">All</option>
                            @for (year of (useTopLevelCompanyTerms ? topLevelYears : subsidiaryYears); track year) {
                                <option [value]="year">{{ year }}</option>
                            }
                        </select>
                    </div>
                }
                @if (!isEditMode && !editLock && showBody && hasEditPermission) {
                    <button class="ace-btn btn-text has-icon btn-primary" (click)="goToEditMode()">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (isEditMode && showBody) {
                    <div style="display: inline-block; vertical-align: middle;">
                        <button class="ace-btn btn-text has-icon btn-primary btn-success"
                                (click)="savePanel()"
                                [disabled]="isLoading">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancelEdit()">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
        @if (showBody) {
            <div class="card-body" style="padding-top: 0;">
                @if (isLoading) {
                    <div class="text-center" style="margin-top: 50px;">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                @if (!isLoading) {
                    <div>
                        @if (!isTopLevel || isEditMode) {
                            <div class="checkbox text-end" [class.disabled]="!isEditMode" style="margin-top: 0;">
                                @if (isEditMode && (isTopLevel || !useTopLevelCompanyTerms)) {
                                    <span class="anchor-style" (click)="configureFeeEscalator()">
                                        @if (allData.feeEscalator) {
                                            <span>
                                                Annual Fixed Fee
                                                Escalator: {{ allData.feeEscalator * 100 | number: '1.2' }}%
                                            </span>
                                        }
                                        @if (!allData.feeEscalator) {
                                            <span>
                                                Configure Annual Fixed Fee Escalator
                                            </span>
                                        }
                                    </span>
                                }
                                @if (!isTopLevel) {
                                    <label style="margin-left: 1em;">
                                        <input type="checkbox"
                                               [(ngModel)]="useTopLevelCompanyTerms"
                                               [disabled]="!isEditMode"
                                               (change)="useTopLevelCompanyChanged()">
                                        Use Top Level Company Terms
                                    </label>
                                }
                            </div>
                        }
                        <table class="table table-condensed contract-terms">
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Property Type</th>
                                    <th class="text-center">Tax Year</th>
                                    <th>Terms</th>
                                    <th></th>
                                    <th></th>
                                    <th class="text-center">Engagement #</th>
                                    <th></th>
                                    <th class="text-center">Site Default</th>
                                    <th></th>
                                </tr>
                            </thead>
                            @if (!isEditMode || useTopLevelCompanyTerms) {
                                <tbody class="contract-terms-view">
                                    @for (
                                        term of (useTopLevelCompanyTerms ? topLevelCompanyContractTerms : currentContractTerms); track term; let
                                        i = $index) {
                                        <tr>
                                            <td>{{ term.contractServiceTypeName }}</td>
                                            <td>{{ term.propertyTypeName }}</td>
                                            <td class="text-center">{{ term.taxYear }}</td>
                                            <td>
                                                <term-rates-and-fees [term]="term"></term-rates-and-fees>
                                            </td>
                                            <td></td>
                                            <td class="text-center">
                                                @if (term.remarks) {
                                                    <button
                                                        class="ace-btn has-icon btn-primary"
                                                        (click)="showComments(term, true)"
                                                        style="margin-left:0.5em;"
                                                        [title]="term.remarks">
                                                        <i class="fa fa-commenting"></i>
                                                    </button>
                                                }
                                            </td>
                                            <td class="text-center">{{ term.engagement }}</td>
                                            <td></td>
                                            <td class="text-center">
                                                <div class="checkbox" style="margin: 0;">
                                                    <label>
                                                        <input type="checkbox" [(ngModel)]="term.siteDefault" disabled>
                                                    </label>
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    }
                                </tbody>
                            }
                            @if (termsAreEditable()) {
                                <tbody class="contract-terms-edit">
                                    @for (term of currentContractTerms; track term; let i = $index) {
                                        @if (term.efAction !== 'delete') {
                                            <tr class="delete-hover">
                                                <td>
                                                    <select [(ngModel)]="term.contractServiceTypeId"
                                                            class="form-select form-select-sm"
                                                            [disabled]="!!term.contractTermDetailId"
                                                            (ngModelChange)="serviceTypeChanged($event, term)">
                                                        @for (service of services; track service) {
                                                            <option [ngValue]="service.id">{{ service.name }}</option>
                                                        }
                                                    </select>
                                                </td>
                                                <td>
                                                    <select [(ngModel)]="term.propertyTypeId"
                                                            class="form-select form-select-sm"
                                                            [disabled]="term.contractServiceTypeId !== ContractServiceType.Appeal && term.contractServiceTypeId !== ContractServiceType.Litigation && term.contractServiceTypeId !== ContractServiceType.LitigationAdmin && term.contractServiceTypeId !== ContractServiceType.LitigationOnly || !!term.contractTermDetailId">
                                                        <option [ngValue]="null">All</option>
                                                        @for (type of propertyTypes; track type) {
                                                            <option [ngValue]="type.propertyTypeId">{{ type.name }}</option>
                                                        }
                                                    </select>
                                                </td>
                                                <td>
                                                    <select [(ngModel)]="term.taxYear"
                                                            class="form-select form-select-sm mx-auto"
                                                            [disabled]="!!term.contractTermDetailId"
                                                            style="width: auto;">
                                                        @for (year of recentYears; track year) {
                                                            <option [ngValue]="year">{{ year }}</option>
                                                        }
                                                    </select>
                                                </td>
                                                <td style="width: 1%; white-space: nowrap;">
                                                    <term-rates-and-fees [term]="term"></term-rates-and-fees>
                                                </td>
                                                <td style="width: 1px;">
                                                    <choose-term-popover [selectedTerm]="term"></choose-term-popover>
                                                </td>
                                                <td class="text-center">
                                                    <button class="ace-btn has-icon btn-primary"
                                                            (click)="showComments(term, false)">
                                                        @if (term.remarks) {
                                                            <i class="fa fa-commenting"></i>
                                                        }
                                                        @if (!term.remarks) {
                                                            <i class="fa fa-comment-o"></i>
                                                        }
                                                    </button>
                                                </td>
                                                <td class="text-center" style="width: 1px;">
                                                    <span>{{ term.engagement }}</span>
                                                </td>
                                                <td style="width: 1px;">
                                                    <button class="ace-btn has-icon btn-primary"
                                                            (click)="lookupEngagement(term)"
                                                            tooltip="Select Engagement Number">
                                                        <i class="fa fa-binoculars"></i>
                                                    </button>
                                                </td>
                                                <td class="text-center">
                                                    <div class="checkbox" style="margin: 0;">
                                                        <label>
                                                            <input type="checkbox"
                                                                   [(ngModel)]="term.siteDefault"
                                                                   [disabled]="term.contractServiceTypeId === ContractServiceType.Misc || term.contractServiceTypeId === ContractServiceType.Hourly">
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <i class="fa fa-close invisible-hover"
                                                       aria-label="Remove Term"
                                                       aria-hidden="true"
                                                       (click)="removeTerm(term, i)"></i>
                                                </td>
                                            </tr>
                                        }
                                    }
                                </tbody>
                            }
                        </table>
                        @if (termsAreEditable()) {
                            <button class="ace-btn btn-primary" (click)="addTerm()">Add Term</button>
                        }
                        @if (showRollForwardYearButton()) {
                            <button class="ace-btn btn-primary" style="margin-left:10px;"
                                    (click)="rollForwardYear()">Roll Forward Year
                            </button>
                        }
                    </div>
                }
            </div>
        }
    </div>
}

<div class="modal fade"
     bsModal
     #addTermYearModal="bs-modal"
     tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <ws-modal-wrapper headerLabel="Choose Year"
                              acceptLabel="OK"
                              [disableSave]="addingYear"
                              (save)="addYear()"
                              (cancel)="addTermYearModal.hide()">
                <div class="row" style="margin-top: 1em;">
                    <div>
                        @if (yearsToAdd) {
                            <ws-select [(ngModel)]="yearToAdd"
                                       [options]="yearsToAdd"
                                       [canSearch]="false"
                                       disabledProperty="disabled"
                                       labelProperty="year"
                                       valueProperty="year"
                                       style="width: 200px;">
                            </ws-select>
                        }
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" [(ngModel)]="rollForwardSiteOverrides"> Roll Forward Site
                                Overrides
                            </label>
                        </div>
                        @if (showFeeEscalator) {
                            <div class="bg-warning" style="padding: 0.5em;">
                                NOTE: A {{ allData.feeEscalator * 100 | number: '1.2-2' }}% annual fixed fee escalator
                                will be applied to the following services:
                                <ul style="margin: 1em 0 0 0">
                                    @for (serviceType of allData.escalatorServiceTypes; track serviceType) {
                                        <li>
                                            {{ getContractServiceTypename(serviceType) }}
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </ws-modal-wrapper>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #configureFeeEscalatorModal="bs-modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <ws-modal-wrapper headerLabel="Configure Fee Escalator"
                              acceptLabel="OK"
                              [excludeModalStyling]="true"
                              [disableSave]="savingFeeEscalator"
                              (save)="saveFeeEscalator()"
                              (cancel)="configureFeeEscalatorModal.hide()">
                <div>
                    <div class="row" style="margin-top: 1em;">
                        Apply Fixed Fee Escalator to:
                    </div>
                    <div class="row" style="margin-left:1em;margin-bottom:1em;">
                        @for (service of services; track service) {
                            <div class="col-md-4">
                                <label class="checkbox">
                                    <input type="checkbox"
                                           [ngModel]="serviceTypeSelected(service.id)"
                                           (ngModelChange)="checkedServiceType(service.id, $event)"/>
                                    {{ service.fullDisplayName || service.name }}
                                </label>
                            </div>
                        }
                    </div>
                    <div class="row">
                        <label>
                            Fee Escalator:
                            <input type="text"
                                   [(ngModel)]="newFeeEscalator"
                                   class="form-control"
                                   currencyMask
                                   [options]="{ allowNegative: false, precision: 2, prefix: '', suffix: '%' }"
                                   style="display:inline-block;width:5em;"/>
                        </label>
                    </div>
                </div>
            </ws-modal-wrapper>
        </div>
    </div>
</div>

